import React, { useState } from 'react';
import { Header } from './components/Header';
import { UrgencyBar } from './components/UrgencyBar';
import { PromoBanner } from './components/PromoBanner';
import { FeaturesSection } from './components/FeaturesSection';
import { ProblemSolutionSection } from './components/ProblemSolutionSection';
import { ReviewsSection } from './components/ReviewsSection';
import { QuickTaskSection } from './components/QuickTaskSection';
import { EasyToUseSection } from './components/EasyToUseSection';
import { CompactSpaceSavingSection } from './components/CompactSpaceSavingSection';
import { FeatureComparisonSection } from './components/FeatureComparisonSection';
import { ProductSpecificationsSection } from './components/ProductSpecificationsSection';
import { FamilyTestimonialsSection } from './components/FamilyTestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { CheckoutPage } from './components/CheckoutPage';
import { SalesNotification } from './components/SalesNotification';
import { Award } from 'lucide-react';
export function App() {
  const [currentPage, setCurrentPage] = useState<'home' | 'checkout'>('home');
  if (currentPage === 'checkout') {
    return <CheckoutPage data-id="element-0" />;
  }
  return <div className="min-h-screen bg-gray-100 flex flex-col items-center justify-center p-4 md:p-8 font-sans" data-id="element-1">
      {/* Sales Notification Popup */}
      <SalesNotification data-id="element-2" />

      {/* Main Banner Container */}
      <div id="banner" className="relative w-full max-w-[1400px] aspect-[2.5/1] min-h-[600px] bg-gray-200 rounded-xl overflow-hidden shadow-2xl" data-id="element-3">
        {/* Top Award Banner */}
        <div className="absolute top-0 left-0 right-0 bg-gray-300/90 backdrop-blur-sm py-2 px-4 flex items-center justify-center gap-2 text-sm font-medium text-gray-800 z-30" data-id="element-4">
          <Award className="w-4 h-4 text-yellow-600" data-id="element-5" />
          <span data-id="element-6">Award-Winning Kitchen Gadget</span>
          <div className="flex gap-0.5" data-id="element-7">
            {[...Array(5)].map((_, i) => <span key={i} className="text-yellow-500" data-id="element-8">
                ⭐
              </span>)}
          </div>
          <span data-id="element-9">Loved by 50,000+ Families</span>
        </div>

        {/* Promo Banner - Below Award Banner */}
        <div className="absolute top-[75px] md:top-[40px] left-0 right-0 z-30" data-id="element-10">
          <PromoBanner data-id="element-11" />
        </div>

        {/* Background Image Layer */}
        <div className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: 'url(https://cdn.magicpatterns.com/uploads/1pDA9HrpVDYeitQDJ432Ze/Gemini_Generated_Image_z6mv8yz6mv8yz6mv.png)'
      }} data-id="element-12" />

        {/* Masking Layer to hide original text on the left */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#dcdcdc] via-[#dcdcdc] to-transparent w-[65%] z-10" data-id="element-13" />

        {/* Additional blur to help blend the mask edge */}
        <div className="absolute inset-y-0 left-[50%] w-[20%] bg-gradient-to-r from-[#dcdcdc] to-transparent blur-xl z-10 opacity-50" data-id="element-14" />

        {/* Content Layer */}
        <div className="relative z-20 w-full h-full flex flex-col" data-id="element-15">
          <Header onNavigateToCheckout={() => setCurrentPage('checkout')} data-id="element-16" />

          {/* Hero Text Content */}
          <div className="flex-1 flex flex-col justify-center px-12 md:px-24 max-w-2xl mt-16" data-id="element-17">
            <h1 className="text-3xl md:text-5xl font-black text-black leading-tight mb-4 tracking-tight" style={{
            textShadow: '1px 1px 0 white, -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white'
          }} data-id="element-18">
              Automatic Fruit Peeling Machine
            </h1>
            <p className="text-xl md:text-2xl text-gray-800 font-medium" style={{
            textShadow: '1px 1px 0 white, -1px -1px 0 white, 1px -1px 0 white, -1px 1px 0 white'
          }} data-id="element-19">
              Peel Fruits & Veggies Instantly, Save Time in the Kitchen
            </p>
          </div>

          <UrgencyBar data-id="element-20" />
        </div>
      </div>

      {/* Features Section */}
      <div id="features" data-id="element-21">
        <FeaturesSection onNavigateToCheckout={() => setCurrentPage('checkout')} data-id="element-22" />
      </div>

      {/* Problem/Solution Section */}
      <div id="problem-solution" data-id="element-23">
        <ProblemSolutionSection data-id="element-24" />
      </div>

      {/* Reviews Section */}
      <div id="reviews" data-id="element-25">
        <ReviewsSection data-id="element-26" />
      </div>

      {/* Quick Task Section */}
      <div id="quick-task" data-id="element-27">
        <QuickTaskSection data-id="element-28" />
      </div>

      {/* Easy to Use Section */}
      <div id="easy-to-use" data-id="element-29">
        <EasyToUseSection data-id="element-30" />
      </div>

      {/* Compact & Space-Saving Section */}
      <div id="compact" data-id="element-31">
        <CompactSpaceSavingSection data-id="element-32" />
      </div>

      {/* Feature Comparison Section */}
      <div id="comparison" data-id="element-33">
        <FeatureComparisonSection data-id="element-34" />
      </div>

      {/* Product Specifications Section */}
      <div id="specifications" data-id="element-35">
        <ProductSpecificationsSection data-id="element-36" />
      </div>

      {/* Family Testimonials Section */}
      <div id="testimonials" data-id="element-37">
        <FamilyTestimonialsSection data-id="element-38" />
      </div>

      {/* FAQ Section */}
      <div id="faq" data-id="element-39">
        <FAQSection data-id="element-40" />
      </div>

      {/* Footer/Outside Context */}
      <div className="mt-8 text-gray-400 text-sm opacity-0 pointer-events-none" data-id="element-41">
        Recreated banner design for KNOVA
      </div>
    </div>;
}